// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

const AdminEvaluationQuickListItem = ({ evaluation, match, contentModule }) => {
  return (
    <Link to={`/admin/authoring/evaluations/${evaluation._id}`} target="_blank" className="-item">
      {evaluation.title}
      <div className="-icon">
        <i className="far fa-external-link"/>
      </div>
    </Link>

  )
}

AdminEvaluationQuickListItem.propTypes = {
  contentModule: PropTypes.object
  , evaluation: PropTypes.object.isRequired
}

export default withRouter(AdminEvaluationQuickListItem);



// WEBPACK FOOTER //
// modules/evaluation/components/AdminEvaluationQuickListItem.js.jsx